<script lang="ts" setup>
import type {PageCollectionItemBase} from "@nuxt/content";

useHead({
    bodyAttrs: {
    },
});

const { page } = defineProps<{
    page: PageCollectionItemBase
}>();
</script>

<template>
  <div>
    <SiteHeader />
    <SiteHero :page="page" />
    <main class="spacer-section">
      <slot/>
    </main>
    <SiteFooter />
  </div>
</template>

<style scoped>

</style>